<template>
  <PlanningMissionDetail :extra="extra" :can-access-contact-informations="true" :display-contact-buttons="true" />
</template>

<script>
  import { EventManager } from "@core/managers/event.manager";
  import { RecruitmentCandidatesService } from "@core/services";
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { DEMAND_TYPES } from "@core/constants";
  import { ETAB_EVENTS, ETAB_ROUTES } from "@etab/config";
  import {
    ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL,
    ACTION_DASHBOARD_SET_DRAWER_TITLE,
    ACTION_RECRUITMENT_GET,
    GETTER_EXTRA_GET_CURRENT,
    GETTER_RECRUITMENT_GET_CURRENT,
  } from "@etab/stores/types";
  import { useExtraStore } from "@etab/stores/extra";
  import { useDashboardStore } from "@etab/stores/dashboard";
  import { useRecruitmentStore } from "@etab/stores/recruitment";
  import { mapStores } from "pinia";

  import PlanningMissionDetail from "@etab/components/extra/PlanningMissionDetail.component.vue";

  export default {
    components: {
      PlanningMissionDetail,
    },
    computed: {
      ...mapStores(useExtraStore, useDashboardStore, useRecruitmentStore),
      missionId() {
        return this.$route.params.missionId;
      },
      extraId() {
        return this.$route.params.extraId;
      },
      extra() {
        return this.extraStore[GETTER_EXTRA_GET_CURRENT];
      },
    },
    created() {
      this.DEMAND_TYPES = DEMAND_TYPES;
      this.events = [
        { name: ETAB_EVENTS.EXTRA.CANCEL_SHIFTS, action: this.cancelShiftsDialog },
        { name: ETAB_EVENTS.RECRUITMENT.OPEN_RECRUITMENT_RECAP, action: this.openRecruitmentRecap },
      ];

      this.registerEvents();
      this.setDrawerTitle();
    },
    beforeUnmount() {
      this.unregisterEvents();
    },
    methods: {
      registerEvents() {
        EventManager.registerAllEvents(this.events);
      },
      unregisterEvents() {
        EventManager.unregisterAllEvents(this.events);
      },
      setDrawerTitle() {
        const name = this.extra.getIdentity().firstname;
        const qualification = this.extra.getMissionQualification().getLabel();
        const title = this.$t("ETAB.PAGES.PLANNING.@SHIFT_DETAIL_TITLE", { name, qualification });
        this.dashboardStore[ACTION_DASHBOARD_SET_DRAWER_TITLE](title);
      },
      cancelShiftsDialog({ extra }) {
        this.$q
          .dialog({
            title: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@TITLE", { name: extra.getIdentity().firstname }),
            message: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@MESSAGE"),
            ok: {
              label: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@CONFIRM"),
              color: "secondary",
            },
            cancel: this.$t("ETAB.PAGES.EXTRA.CANCEL_SHIFTS_DIALOG.@CLOSE"),
          })
          .onOk(() => this.cancelShifts({ extra }));
      },
      async cancelShifts({ extra }) {
        try {
          this.$_startGlobalLoading();
          const demandId = this.missionId;
          const extraId = this.extraId;
          await RecruitmentCandidatesService.cancelFutureShifts({ demandId, extraId });
          EventManager.emit(ETAB_EVENTS.SHIFT_PLANNING.REFRESH);
          this.$router.push({ name: ETAB_ROUTES.dashboard.planning.root.name }).catch((suppressedError) => {});
        } catch (error) {
          NotificationsManager.contactEtabSupport();
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      async openRecruitmentRecap() {
        try {
          this.$_startGlobalLoading();
          const demandId = this.missionId;
          const demandType = DEMAND_TYPES.AE;
          await this.recruitmentStore[ACTION_RECRUITMENT_GET]({ demandId, demandType });
          const recap = this.recruitmentStore[GETTER_RECRUITMENT_GET_CURRENT];
          this.dashboardStore[ACTION_DASHBOARD_OPEN_RECRUITMENT_RECAP_MODAL]({ recap });
        } catch (error) {
          NotificationsManager.error({ message: "ERRORS.@SOMETHING_WENT_WRONG" });
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
    },
  };
</script>
